import {Link} from "@/shared/ui/Link";
import {Svg} from "@/shared/ui/Svg";
// import {Button} from "@/shared/ui/Button";
import {useLoginOrRegistrationModalStore} from "@/widgets/login-or-registration-modal";
import styles from "../HeaderMain/HeaderMain.module.scss";

type Props = {
    authCheck: boolean;
    activeOrders: number;
}

export const ProfileIcon = (
    {
        authCheck,
        activeOrders
    }: Props
) => {
    const openModal = useLoginOrRegistrationModalStore(s => s.actions.openModal);

    const content = (
        <>
            <Svg id={`profile`} className={styles.profileIcon} />
            {activeOrders > 0 && (<span className={styles.profileIconDot} />)}
        </>
    );

    if (authCheck) {
        return (
            <Link href={`/home?profile=profile`} className={styles.profileIconContainer}>
                {content}
            </Link>
        );
    }

    return (
        <button type={`button`} onClick={openModal} className={styles.profileIconContainer}>
            {content}
        </button>
    );

    // return (
    //     <Button variant={`icon`} onClick={openModal} className={styles.profileIconContainer}>
    //         {content}
    //     </Button>
    // );
}
